<template>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Выполненный сервис</h2>
        <button type="button" class="close" @click="$emit('hide')" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="performed-service-nav-pills container-fluid pb-2">
        <ul class="nav nav-pills">
          <li class="nav-item">
            <a class="nav-link" :class="{active: !show_info}" href="#" @click.prevent="show_info = false">Задачи</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" :class="{active: show_info}" href="#" @click.prevent="show_info = true">Информация</a>
          </li>
        </ul>
      </div>

      <div v-if="!show_info">
        <div class="navbar-subnav" v-if="data && data.tasks">
          <div class="container-fluid">
            <ul class="nav nav-subnav">
              <li
                v-for="(task, i) in data.tasks"
                class="nav-item pr-3"
                :class="{active: i == active_task_index}"
              >
                <a href="#" @click.prevent="active_task_index = i" class="nav-link px-0">{{ task.type.name }}</a>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="currentTask">
          <div class="modal-body" v-if="currentTask.params">
            <template v-if="currentTask.params.bag_id">
              <h4 class="mt-2 mb-0">Номер мешка</h4>
              <div>{{currentTask.params.bag_id}}</div>
            </template>
            <template v-if="currentTask.params.coins_25">
              <h4 class="mt-2 mb-0">Показатели счетчика монетоприёмника, руб.</h4>
              <div>{{currentTask.params.coins_25}}</div>
            </template>
            <template v-if="currentTask.params.coins_25_before">
              <h4 class="mt-2 mb-0">Показатели счетчика монетоприёмника до сервиса, руб.</h4>
              <div>{{currentTask.params.coins_25_before}}</div>
            </template>
            <template v-if="currentTask.params.coins_25_after">
              <h4 class="mt-2 mb-0">Показатели счетчика монетоприёмника после сервиса, руб.</h4>
              <div>{{currentTask.params.coins_25_after}}</div>
            </template>
            <template v-if="currentTask.params.withdrawn_coins">
              <h4 class="mt-2 mb-0">Сумма изъятых монет, руб.</h4>
              <div>{{currentTask.params.withdrawn_coins}}</div>
            </template>
            <template v-if="currentTask.params.inserted_coins">
              <h4 class="mt-2 mb-0">Сумма загруженных монет, руб.</h4>
              <div>{{currentTask.params.inserted_coins}}</div>
            </template>
          </div>
          <div class="modal-body" v-if="currentTask.comment">
            <h4>Комментарий</h4>
            <div class="performed-service-comment">{{currentTask.comment}}</div>
          </div>
          <table class="table mb-0">
            <thead>
            <tr>
              <th>{{currentTask.type.name}}</th>
              <th></th>
            </tr>
            </thead>
            <tbody v-if="currentTask">
            <tr v-for="(item, index) in currentTask.checklist_elements">
              <td>
                {{index+1}}. {{item.name}}
                <div class="performed-service-comment mt-2" v-if="item.comment">{{item.comment}}</div>
              </td>
              <td width="1">
                <div class="squaredThree" v-if="item.type === 'check'">
                  <div class="custom-control custom-checkbox custom-control-no-label">
                    <input type="checkbox" class="custom-control-input" disabled :checked="item.selected">
                    <label class="custom-control-label"></label>
                  </div>
                </div>
                <div v-else>{{item.mark}}</div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-body performed-service-info-tab" v-else>
        <div v-if="data && data.service">
          <dl class="m-0">
            <template v-if="data.service.machine">
              <h3>Автомат</h3>
              <div>{{data.service.machine.serial_number}}</div>
            </template>
            <template v-if="data.service.executor">
              <h3>Выполнил</h3>
              <div>{{data.service.executor | fullName}}</div>
            </template>
            <template>
              <h3>Время проведения сервиса</h3>
              <div>{{data.service.date | formatDate}}</div>
            </template>
            <div class="row">
              <div class="col-md" v-if="data.service.hydrated_part_params.parts.new_parts.length || data.service.hydrated_part_params.parts.removed_parts.length">
                <h3>Детали</h3>
                <div>
                  <table v-if="data.service.hydrated_part_params.parts.removed_parts.length" class="table table-sm performed-service-table-parts">
                    <tr class="table-light">
                      <th colspan="2">Снятые</th>
                    </tr>
                    <tbody>
                    <tr v-for="part in data.service.hydrated_part_params.parts.removed_parts">
                      <td>{{part|get('part.name')}}</td>
                      <td>{{part.amount}} {{part|get('part.measure')}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <table v-if="data.service.hydrated_part_params.parts.new_parts.length" class="table table-sm performed-service-table-parts">
                    <tr class="table-light">
                      <th colspan="2">Установленные</th>
                    </tr>
                    <tbody>
                    <tr v-for="part in data.service.hydrated_part_params.parts.new_parts">
                      <td>{{part|get('part.name')}}</td>
                      <td>{{part.amount}} {{part|get('part.measure')}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-md" v-if="data.service.hydrated_part_params.extra_parts.new_parts.length || data.service.hydrated_part_params.extra_parts.removed_parts.length">
                <h3>Оборудование</h3>
                <div>
                  <table v-if="data.service.hydrated_part_params.extra_parts.removed_parts.length" class="table table-sm performed-service-table-parts">
                    <tr class="table-light">
                      <th colspan="2">Снятое</th>
                    </tr>
                    <tbody>
                    <tr v-for="part in data.service.hydrated_part_params.extra_parts.removed_parts">
                      <td>{{part|get('extra_part.name')}}</td>
                      <td>{{part.amount}} {{part|get('extra_part.measure')}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <table v-if="data.service.hydrated_part_params.extra_parts.new_parts.length" class="table table-sm performed-service-table-parts">
                    <tr class="table-light">
                      <th colspan="2">Установленное</th>
                    </tr>
                    <tbody>
                    <tr v-for="part in data.service.hydrated_part_params.extra_parts.new_parts">
                      <td>{{part|get('extra_part.name')}}</td>
                      <td>{{part.amount}} {{part|get('extra_part.measure')}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <template v-if="data.service.kkt_type">
              <h3>Кассовая лента</h3>
              <div>{{data.service.kkt_type.name}}</div>
            </template>
            <template v-if="data.service.banknotes_summary">
              <h3>Купюры</h3>
              <div>{{data.service.banknotes_summary}}р.</div>
            </template>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    data () {
      return {
        active_task_index: 0,
        show_info: false,
      }
    },
    props: ['id'],
    methods: {},
    computed: {
      currentTask () {
        if (this.data && this.data.tasks) {
          return this.data.tasks[this.active_task_index]
        }
      },
    },
    asyncComputed: {
      data () {
        return api
          .get(`services/performed/${this.id}`)
          .then(({data}) => data)
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .performed-service-nav-pills {
    background: $gray-200;
    font-weight: $font-weight-bold;
    border-bottom: 2px solid $gray-300;
    .nav-link {
      padding: .3rem .6rem;
    }
  }
  .performed-service-comment {
    padding-left: .5rem;
    border-left: 5px solid #99ff99;
  }
  .performed-service-table-parts {
    max-width: 320px;
    tr td:last-child {
      width: 1px;
      white-space: nowrap;
    }
  }
  .performed-service-info-tab {
    h3 {
      margin-top: 1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/service-modal-performed.vue